var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('weather',{attrs:{"api-key":"bfca1b5c8ffd519c067f6d53cb25c639","title":"Weather","latitude":"28.142783","longitude":"-15.417307","language":"es","hide-header":"","units":"si","text-color":"white","bar-color":"white"}})}
var staticRenderFns = []

export { render, staticRenderFns }